import './App.css';
import React from 'react';
import {Routes, Route} from "react-router-dom"
//Components
import RateUsHome from './components/dashboard/RateUsHome';
import ThreeStarThanks from './components/dashboard/ThreeStarThanks';
import FourStarThanks from './components/dashboard/FourStarThanks';

function App() {  

  return (
    <React.Fragment>
      <div className="container d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <div className="col-sm-11 col-md-11 col-lg-10 col-xl-7" style={{ fontSize: "18px", fontFamily: "Calibri", backgroundColor: 'rgb(250,250,255)' }}>
          <Routes>
            <Route path="/" element={<RateUsHome />} />
            <Route path="/thanks" element={<ThreeStarThanks />} />
            <Route path="/thankyou" element={<FourStarThanks />} />
          </Routes>
        </div>
      </div>
    </React.Fragment>
  );
}

export default App;
